import { ApplicationView } from "@mixitone/mvc";
import { DashLayout } from "../../../Components/DashLayout";

const RegistrationLoadingSkeleton = () => {
  return (
    <DashLayout title="Loading...">
      <div className="flex flex-col gap-6 pb-6">
        <div className="mb-3 mt-1 flex h-4 animate-pulse gap-2">
          <div className="w-32 rounded bg-gray-200" />
          <div className="w-24 rounded bg-gray-200" />
        </div>
      </div>
    </DashLayout>
  );
};

export default ApplicationView(RegistrationLoadingSkeleton);
